import React from "react";
import { Alert, Badge, Button, Table } from "react-bootstrap";

export default function ManageStudentsCard({
  activeKey,
  filteredAPIDateStudentResults,
  refreshStatus,
  selectedDays,
  selectedLocation,
  fetchedStudents,
  unsavedManuallyAddedStudents,
  loading,
  dataDirty,
  locationSelector,
  noDateSelectedPrompt,
  onSetActiveKey,
  onRefreshStatus,
  onModalChange,
  onAddNewStudents,
}) {
  if (selectedDays.length === 0) {
    return noDateSelectedPrompt;
  }

  if (selectedLocation.length === 0) {
    return (
      <div>
        <Alert variant="warning" style={{ marginBottom: "1rem" }}>
          No location selected. Please choose a road test location to continue.
        </Alert>
        {locationSelector}
      </div>
    );
  }

  if (!fetchedStudents) {
    return (
      <div>
        <p>No date selected. Please select a date to add, move, or delete students.</p>
        <Button variant="primary" onClick={() => onSetActiveKey("selectDays")}>
          Select Day Range
        </Button>
      </div>
    );
  }

  return (
    <div>
      {refreshStatus && (
        <Alert variant="success">
          <strong>{refreshStatus}</strong>
        </Alert>
      )}

      {/* Add Students */}
      <div style={{ marginBottom: "1.5rem" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.5rem" }}>
          <h5 style={{ margin: 0 }}>Add Student</h5>
        </div>
        <Button variant="outline-primary" size="sm" onClick={() => onModalChange(true, "add")}>
          + Add New Student
        </Button>
      </div>

      {/* Unsaved Students */}
      {unsavedManuallyAddedStudents.length > 0 && (
        <div style={{ marginBottom: "1.5rem" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.5rem" }}>
            <h5 style={{ margin: 0 }}>
              Unsaved Students{" "}
              <Badge variant="warning">{unsavedManuallyAddedStudents.length}</Badge>
            </h5>
            <Button variant="success" size="sm" disabled={loading} onClick={onAddNewStudents}>
              Save All
            </Button>
          </div>
          <Table striped bordered hover responsive size="sm">
            <thead className="thead-light">
              <tr className="d-flex">
                <th className="col-4">Package</th>
                <th className="col-4">First Name</th>
                <th className="col-4">Last Name</th>
              </tr>
            </thead>
            <tbody>
              {unsavedManuallyAddedStudents.map((x) => (
                <tr key={x.student.timestamp} className="d-flex">
                  <td className="col-4">{x.student.selectedPackage}</td>
                  <td className="col-4">{x.student.fName}</td>
                  <td className="col-4">{x.student.lName}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {/* Current Students */}
      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "0.5rem" }}>
          <h5 style={{ margin: 0 }}>
            Current Students{" "}
            {filteredAPIDateStudentResults.length > 0 && (
              <Badge variant="primary">{filteredAPIDateStudentResults.length}</Badge>
            )}
          </h5>
          <Button variant="outline-secondary" size="sm" disabled={dataDirty} onClick={() => onRefreshStatus(activeKey)}>
            Refresh
          </Button>
        </div>

        {filteredAPIDateStudentResults.length > 0 ? (
          <>
            <Table striped bordered hover responsive size="sm">
              <thead className="thead-light">
                <tr className="d-flex">
                  <th className="col-4">Package</th>
                  <th className="col-4">First Name</th>
                  <th className="col-4">Last Name</th>
                </tr>
              </thead>
              <tbody>
                {filteredAPIDateStudentResults.map((x) => (
                  <tr key={x.timestamp} className="d-flex">
                    <td className="col-4">{x.selectedPackage}</td>
                    <td className="col-4">{x.fName}</td>
                    <td className="col-4">{x.lName}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginTop: "0.5rem" }}>
              <Button variant="outline-secondary" size="sm" onClick={() => onModalChange(true, "move")}>
                Move Student
              </Button>
              <Button variant="outline-secondary" size="sm" onClick={() => onModalChange(true, "copy")}>
                Copy Student
              </Button>
              <Button variant="outline-danger" size="sm" onClick={() => onModalChange(true, "delete")}>
                Delete Student
              </Button>
            </div>
          </>
        ) : (
          <p className="text-muted" style={{ marginTop: "0.5rem" }}>No students found for this date and location.</p>
        )}
      </div>
    </div>
  );
}
